module.exports = __webpack_public_path__ + "img/imagen-web-logo.249d6097.jpg";